import React, { useMemo, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import CoreIncentiveDistribution from "../pages/CoreIncentiveDistribution";
import Details from "../pages/Details";
import IncentiveReport from "../pages/IncentiveReport";

import Login from "../pages/Login";
import Meetings from "../pages/Meetings";
import MemberDetails from "../pages/MemberDetails";
import MemberDownline from "../pages/MemberDownline";
import Register from "../pages/Register";
import CoreWithdrawal from "../pages/CoreWithdrawal"

function RoutesAdmin() {
  let path = useLocation();
  let AllRoutes = useMemo(() => React.lazy(() => import("./index")), []);
  return (
    <Suspense fallback={<>Loading...</>}>
      <AllRoutes path={path}>
        <Routes>
          <Route path="/member-downline" element={<MemberDownline />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/core-incentive"
            element={<CoreIncentiveDistribution />}
          />
          <Route path="/incentive-reports" element={<IncentiveReport />} />
          <Route path="/" element={<MemberDetails />} />
          <Route path="/register" element={<Register />} />
          <Route path="/meetings" element={<Meetings />} />
          <Route path="/details" element={<Details />} />
          <Route path="/withdrawal" element={<CoreWithdrawal/>}/>
        </Routes>
      </AllRoutes>
    </Suspense>
  );
}

export default RoutesAdmin;
